import type { Router } from 'vue-router';

/**
 * Navigates to a post or note thread based on its AT URI
 * @param uri The at:// URI of the post/note
 * @param router Vue Router instance
 * @param preferredHandle Optional handle to use instead of extracting from URI (e.g. if DID is in URI but handle is known)
 */
export const viewThreadByUri = (uri: string, router: Router, preferredHandle?: string) => {
  if (!uri) return;
  const parts = uri.split('/');
  const rkey = parts.pop();
  
  // Detect collection
  const isNote = uri.includes('id.gamedev.notes');
  const isRepost = uri.includes('app.bsky.feed.repost');
  
  // If preferredHandle is provided, we use it directly. Otherwise, try to extract.
  let handle = preferredHandle;
  if (!handle) {
    handle = parts[2];
    // If we can find the collection, the handle is just before it
    const collectionIndex = parts.findIndex(p => p.includes('app.bsky.feed.') || p.includes('id.gamedev.'));
    if (collectionIndex > 2) {
      handle = parts[collectionIndex - 1];
    }
  }

  if (isNote) {
    router.push(`/profile/${handle}/note/${rkey}`);
  } else if (isRepost) {
    // We can't view a repost record as a thread, so just go to profile
    router.push(`/profile/${handle}`);
  } else {
    // Default to post for bsky.app compatibility
    router.push(`/profile/${handle}/post/${rkey}`);
  }
};
